import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=190b021a&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports